import CXMApiClient from "../CXMApiClient";

function initialState() {
    return null;
  }
  
const state = initialState();
  
const getters = null;

const actions = {
  getTagNames: async function(context, payload) {
    let client = new CXMApiClient();
    let response = await client.ProcessRequest(
      "post",
      "crm/GetTagByTagTypeIds",
      payload
    );
    return response ? response.data : null;
  },
}

const mutations = null;

export default {
  state,
  getters,
  actions,
  mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/Tag.js